/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.app_=window.app_||{},app_.init=function(){document.querySelectorAll(".parallax-discover").forEach(function(a){var b=a.querySelector(".ImageHero__Wrapper"),c=a.querySelector(".ImageHero__ImageWrapper .img-cover.img-cover-left"),d=a.querySelector(".ImageHero__ImageWrapper .img-cover.img-cover-right");if(!c||!d)return!1;if(window.gsap.set(c,{width:window.innerWidth<768?"24px":"80px"}),window.gsap.set(d,{width:window.innerWidth<768?"24px":"80px"}),b)var h=window.gsap.fromTo(b,{y:"50%",opacity:0,ease:"power2.out"},{y:"-50%",opacity:1,ease:"power2.out"});var e=window.gsap.fromTo(c,{width:window.innerWidth<768?"24px":"80px",ease:"none"},{width:"0px",ease:"Power1.ease0ut"}),f=window.gsap.fromTo(d,{width:window.innerWidth<768?"24px":"80px",ease:"none"},{width:"0px",ease:"Power1.ease0ut"}),g=window.gsap.timeline().add([e,f]);b&&(g=window.gsap.timeline().add([h,e,f])), z="top top+=85px",window.innerWidth<768&&(z="top top+=65px"),ScrollTrigger.create({trigger:a,animation:g,pin:!0,scrub:.6,start:z,end:"+=50%"})})}
$(document).ready(function() {
  
  var parallaxSec=document.querySelector(".parallax-discover");window.gsap&&parallaxSec&&(window.gsap.registerPlugin(ScrollTrigger),app_.init());
 
  $('#material-tabs').each(function() {
    var $active, $content, $links = $(this).find('a');
    $active = $($links[0]);
    $active.addClass('active');
    $content = $($active[0].hash);
    $links.not($active).each(function() {
        $(this.hash).hide();
    });

    $(this).on('click', 'a', function(e) {
        $active.removeClass('active');
        $content.hide();
        $active = $(this);
        $content = $(this.hash);
        $active.addClass('active');
        $content.show();
        e.preventDefault();
    });
  });
 
});

AOS.init();